import { GetSidebarItemFn } from "@/components/layout/Sidebar/sidebar.types";
import { dashboardItem, engineeringMenu } from "@/features/views/sidebar-items/sidebar-items";

const myOverviewItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "technicians",
    title: "My Overview",
    icon: "lely-icon-group",
});

export const technicianSidebarItems: GetSidebarItemFn[] = [dashboardItem, myOverviewItem, engineeringMenu];
